export interface YaClickEventType {
  event: string;
  sourcePage: string;
  sourceComponent: string;
  name: string;
}

export interface YaSendFormEventType {
  sourcePage: string;
  sourceComponent: string;
  event: string;
  name: string;
  result?: string;
}

export const yaEvents = {
  clickProductCardBanks: {
    sourceComponent: 'card',
    name: 'Банки',
  },
  clickProductCardProviders: {
    sourceComponent: 'card',
    name: 'Поставщики услуг',
  },
  clickProductCardPaymentServices: {
    sourceComponent: 'card',
    name: 'Платежные сервисы',
  },
  clickProductCardProviderAccount: {
    sourceComponent: 'card',
    name: 'лк поставщика',
  },
  clickHeaderBanks: {
    sourceComponent: 'header',
    name: 'Банки',
  },
  clickHeaderPaymentServices: {
    sourceComponent: 'header',
    name: 'Платежные сервисы',
  },
  clickHeaderProviders: {
    sourceComponent: 'header',
    name: 'Поставщики услуг',
  },
  clickHeaderProviderAccount: {
    sourceComponent: 'header',
    name: 'лк поставщика',
  },
  clickHeaderApplication: {
    sourceComponent: 'header',
    name: 'Оставить заявку',
  },
  go_to_lk_from_header: {
    event: 'go_to_lk_from_header',
    sourceComponent: 'header',
    name: 'Личный кабинет поставщика услуг',
  },
  go_to_individual_lk_from_header: {
    event: 'go_to_individual_lk_from_header',
    sourceComponent: 'header',
    name: 'Личный кабинет поставщика услуг',
  },
  clickHeaderWork: {
    sourceComponent: 'header',
    name: 'Работа у нас',
  },
  clickHeaderDocuments: {
    sourceComponent: 'header',
    name: 'Документы',
  },
  clickHeaderContacts: {
    sourceComponent: 'header',
    name: 'Контакты',
  },
  clickHeaderEngine: {
    sourceComponent: 'header',
    name: 'Engine',
  },
  clickFooterBanks: {
    sourceComponent: 'footer-link',
    name: 'банки',
  },
  clickFooterPaymentServices: {
    sourceComponent: 'footer-link',
    name: 'платежные сервисы',
  },
  clickFooterProviders: {
    sourceComponent: 'footer-link',
    name: 'поставщики услуг',
  },
  clickFooterProviderAccount: {
    sourceComponent: 'footer-link',
    name: 'лк поставщика',
  },
  clickFooterWork: {
    sourceComponent: 'footer-link',
    name: 'работа у нас',
  },
  clickFooterDocuments: {
    sourceComponent: 'footer-link',
    name: 'документы',
  },
  clickFooterContacts: {
    sourceComponent: 'footer-link',
    name: 'контакты',
  },
  clickFooterEngine: {
    sourceComponent: 'footer-link',
    name: 'Engine',
  },
  clickFooterA3Phone: {
    sourceComponent: 'footer-link',
    name: 'номер телефона а-3',
  },
  clickFooterBetaSite: {
    sourceComponent: 'footer-link',
    name: 'Сайт беты',
  },
  clickWantToTry: {
    sourceComponent: 'button',
    name: 'Попробовать',
  },
  clickArrowPrevious: {
    sourceComponent: 'reviews-slider-button',
    name: 'Стрелка влево',
  },
  clickArrowNext: {
    sourceComponent: 'reviews-slider-button',
    name: 'Стрелка вправо',
  },
  clickButtonTryHero: {
    sourceComponent: 'try button',
    name: 'топ страницы',
  },
  clickProviderAccountTryFourSteps: {
    sourceComponent: 'try button',
    name: '4 шага',
  },
  sendApplicationFormSuccess: {
    sourceComponent: 'form',
    name: 'ApplicationForm',
    result: 'success',
  },
  sendApplicationFormErr: {
    sourceComponent: 'form',
    name: 'ApplicationForm',
    result: 'failed',
  },
  hideApplicationForm: {
    name: 'Вернуться назад',
    sourceComponent: 'button',
  },
  toVacancies: {
    sourceComponent: 'header',
    name: 'К вакансиям',
  },
  showMap: {
    sourceComponent: 'link',
    name: 'Показать на карте',
  },
  sendResumeButton: {
    sourceComponent: 'button',
    name: 'кнопка Отправить резюме',
  },
  sendResumeFormSuccess: {
    sourceComponent: 'form',
    name: 'ResumeForm',
    result: 'success',
  },
  sendResumeFormError: {
    sourceComponent: 'form',
    name: 'ResumeForm',
    result: 'failed',
  },
  //Новые события для лендинга ЛК
  clickTryFree: {
    event: 'go_to_lk',
    sourceComponent: 'HeroBlock',
    name: 'Попробовать бесплатно',
  },
  clickStartWorkWithUs: {
    event: 'go_to_lk',
    sourceComponent: 'Почему мы',
    name: 'Начать работу с нами',
  },
  sendHaveQuestionsFormSuccess: {
    sourceComponent: 'form',
    name: 'Остались вопросы',
    result: 'success',
  },
  sendHaveQuestionsFormError: {
    sourceComponent: 'form',
    name: 'Остались вопросы',
    result: 'failed',
  },
  sendHaveQuestionsFormFirstInteraction: {
    event: 'have_questions_form_first_interaction',
    sourceComponent: 'form',
    name: 'Остались вопросы',
  },
};
